import { z } from 'zod/v3';
import {
  errorMap,
  transformNull,
  transformNullish,
  zCode,
  zValidPeriod,
} from '../../../common/utils';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmValidFormDataSchema.translations.json';
import { zAlgorithmType } from './zAlgorithmType';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-valid-form-data-schema',
);
addTranslations(translations);

export const AlgorithmValidFormDataSchema = z.object({
  id: transformNull(z.number().readonly(), -1),
  typeCode: zAlgorithmType,
  dataObjectDescriptionVersionId: transformNullish(z.number().readonly(), -1),
  code: zCode(),
  groupCode: z.string(),
  sequenceNumber: z.preprocess(
    Number,
    z.number(errorMap(() => t('validation.sequenceNumber.required'))).min(1),
  ),
  validPeriod: zValidPeriod(),
  statusId: z.number(errorMap(() => t('validation.statusId.required'))).min(1),
  description: z.string(),
  execAfterAggregation: z.boolean().nullable(),
  filterClause: z.string(),
  aggregatePeriods: z.boolean().nullable(),
  expression: z.string(),
});
